var $087bfd4dff7c7244$exports = {};
$087bfd4dff7c7244$exports = {
    "clear": `Izbri\u{161}i`,
    "invalid": `(neva\u{17E}e\u{107}e)`,
    "loading": `U\u{10D}itavam...`,
    "noResults": `Nema rezultata`,
    "valid": `(va\u{17E}e\u{107}e)`
};


export {$087bfd4dff7c7244$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
